import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useLazyDataManager } from '@office-start/hooks-utility';
import { useEncryptionKey, useIdentity } from '@office-start/identity-service';
import { useRecommendedConfig } from '@office-start/recommended-config-service';
import { useMemo } from 'react';
import { getRecommendedDataProvider } from '../getRecommendedDataProvider';
export var useRecommendedDataProvider = function (providerType) {
    var encryptionKeyResult = useEncryptionKey().data;
    var identity = useIdentity().data;
    var officeComponentContext = useOfficeComponentContext().data;
    var recommendedConfig = useRecommendedConfig().data;
    var providerProps = useMemo(function () {
        if (!encryptionKeyResult ||
            !identity ||
            !officeComponentContext ||
            !recommendedConfig) {
            return undefined;
        }
        return {
            encryptionKeyResult: encryptionKeyResult,
            identity: identity,
            officeComponentContext: officeComponentContext,
            providerType: providerType,
            recommendedConfig: recommendedConfig,
        };
    }, [
        encryptionKeyResult,
        identity,
        officeComponentContext,
        providerType,
        recommendedConfig,
    ]);
    var provider = useLazyDataManager(getRecommendedDataProvider, providerType, providerProps);
    return provider;
};
//# sourceMappingURL=useRecommendedDataProvider.js.map